import { Combobox, ComboboxExtrasButton } from '@squareup/dex-ui';
import React, { FC, memo, useCallback, useMemo } from 'react';

import { ApiExplorerFieldSpecialValuesDropdown } from '../helpers/ApiExplorerFieldSpecialValuesDropdown';
import { usePrimitiveProps } from '../hooks/nullable-hooks';
import { ApiExplorerPrimitiveFieldProps } from '../props';

const strings = {
  boolean: {
    placeholder: 'Select',
    true: 'True',
    false: 'False',
  },
};

interface Props extends ApiExplorerPrimitiveFieldProps {}

const booleanFieldValues = {
  true: strings.boolean.true,
  false: strings.boolean.false,
};

const dropdownValues = [
  { value: booleanFieldValues.true },
  { value: booleanFieldValues.false },
];

const ApiExplorerBooleanField: FC<Props> = memo(
  ({ currentValue, name, onChange, path, actionButton, type, isNullable }) => {
    const onSelectChangeCallback = useCallback(
      (newValue: string) => {
        if (newValue === booleanFieldValues.true) {
          onChange(true, path);
        } else if (newValue === booleanFieldValues.false) {
          onChange(false, path);
        }
      },
      [onChange, path]
    );

    const currentSelectValue = useMemo(() => {
      if (currentValue === true) {
        return booleanFieldValues.true;
      } else if (currentValue === false) {
        return booleanFieldValues.false;
      } else {
        return undefined;
      }
    }, [currentValue]);

    const { placeholder, icon } = usePrimitiveProps(name, currentValue);

    return (
      <Combobox
        name={name}
        placeholder={placeholder}
        readOnly={true}
        value={currentSelectValue}
        onChange={onSelectChangeCallback}
        type={type}
        actionButton={actionButton}
        comboboxValues={dropdownValues}
        leadingAccessory={icon}
        extrasButton={
          <ApiExplorerFieldSpecialValuesDropdown
            currentValue={currentSelectValue}
            showNullable={isNullable}
            showEmptyString={false}
            path={path}
            onChange={onChange}
            trigger={<ComboboxExtrasButton />}
          />
        }
      />
    );
  }
);

ApiExplorerBooleanField.displayName = 'ApiExplorerBooleanField';

export { ApiExplorerBooleanField };
